
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Qui le fabrique?`}</em></p>
    <p>{`L’Ad26.COV2.S a été développé par Janssen-Cilag International N.V., filiale
européenne (basée en Belgique) du groupe américain Johnson&Johnson.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;